import { forwardRef } from 'react';
import { Field, WrappedFieldProps } from 'redux-form';
import { TextareaProps } from '@optimus-web/core';
import { getError } from '../../utils';
import { TextareaField as TextareaFieldBase } from '../Textarea';

type AreaFieldRendererProps = WrappedFieldProps & TextareaProps;

export const AreaFieldRenderer = ({ input, meta, ...other }: AreaFieldRendererProps) => (
    // @ts-expect-error $TSFixMeError: Type '{ checked?: boolean | undefined; value: any; onBlur: EventOrValueHandler<FocusEvent<any, Element>>; onChange: Even...
    <TextareaFieldBase error={getError(meta)} {...other} {...input} />
);

const AreaField = forwardRef<HTMLElement, TextareaProps>((props, ref) => (
    // @ts-expect-error $TSFixMeError: No overload matches this call.
    <Field component={AreaFieldRenderer} ref={ref} {...props} />
));

export default AreaField;
